import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const agreementdocumenthistory = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/agreement/{profile}/agreement-document',
    app: 'agreement'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'agreement', model: 'agreementdocumenthistory' }
    ),
    { }
  )
)()

export { agreementdocumenthistory, TYPES }
